export default "__VITE_ASSET__Cy5XDluW__"